import React from 'react';
import { Container, Row, Col } from 'react-bootstrap'
import Alert from '../common/modal/Alert';
import Loading from '../common/modal/Loading';
import FormTemplate from "../common/form/FormTemplate";
import LoginTop from "../../components/top/LoginTop";
import axios from "axios";
import configData from "../../config/config.json";
import usStates from "../../config/us_states_no_blank_entry.json";
import { connect } from "react-redux";

import { formatPhone, formatInternationalPhone, formatZip } from "../common/function/formattingUtils.js";
import { validateUser, trimUserFields } from "../common/function/userValidation.js";
import Footer from '../bottom/Footer'
import { LOADING_STATUES, ALERT_TYPES, PASSWORD_RULES } from "../../components/constants/constants";
import translations from "../../config/translation/login_translations.json"

const mapStateToProps = (state) => {
	return {
		countyStateCode: state.productPropertiesReducer.countyStateCode,
		language: state.languageReducer ? state.languageReducer : 'ENGLISH'
	};
}

class RegisterBig extends React.Component {
	state = {
		username: "",
		firstName: "",
		lastName: "",
		company: "",
		address: "",
		city: "",
		state: this.props.countyStateCode,
		zip: "",
		email: "",
		phoneFormatType: 'STANDARD',
		phoneInternational: '',
		phoneStandard: '',
		password: "",
		passwordConfirm: "",
		showAlert: false,
		alertMessage: "",
		alertType: ALERT_TYPES.OK,
		status: "",
		errors: {},
		redirectToLogin: false
	  }

	showLoading = () => {
		if (this.state.status === "") {
			this.setState({
				status: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

	handleChange = (event) => {
		event.preventDefault();
	
		let value = event.target.value;
		if (event.target.id === 'phoneStandard') {
		   	value = formatPhone(value, this.state.phone);
		} else if (event.target.id === 'phoneInternational') {
			value = formatInternationalPhone(value);
		} else if (event.target.id === 'zip') {
			value = formatZip(value);
		}

		this.setState({
		   [event.target.id]: value,
		   errors: {}
		})
	}
	
	validateAndSubmit = () => {
		let errors = validateUser(this.state);
		if (errors && Object.keys(errors).length > 0) {
			this.setState({errors});
			return;
		}

		if (this.showLoading() === true) {

			const { passwordConfirm, status, 		
				 showAlert, alertMessage, redirectToLogin, errors, 
				 phoneInternational, phoneStandard,
				 ...request } = this.state; // remove UI only fields before submitting

			if (this.state.phoneFormatType === 'INTERNATIONAL') {
				request.phone = this.state.phoneInternational;
			} else {
				request.phone = this.state.phoneStandard;
			}

			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "auth/signUp", request, { withCredentials: true })
				.then((response) => {
					this.setState({status: "", redirectToLogin: true}, this.showAlert("We've emailed you a link.  Please follow the link to complete your registration.", ALERT_TYPES.OK));
				}, (error) => {
					this.setState({status: "", redirectToLogin: false}, this.showAlert(error.response?.data?.message || "Something went wrong. Please try again.", ALERT_TYPES.WARNING));
				});
		}
	}

	handleSubmit = (event) => {
		event.preventDefault();

		const trimmedUserFields = trimUserFields(this.state);
		this.setState({ ...trimmedUserFields }, function () {
			this.validateAndSubmit();
		});
	}
	
	handleCancel = (event) => {
		event.preventDefault();
		this.props.history.push('/login');
	}

	showAlert = (alertMessage, alertType = ALERT_TYPES.OK) => {
		this.setState({
		  showAlert: true,
		  alertType,
		  alertMessage
		})
	  }

	hideAlert = () => {
		this.setState({
			showAlert: false,
			alertType: ALERT_TYPES.OK,
			alertMessage: ""
		})
		if (this.state.redirectToLogin) {
			this.props.history.push('/login');
		}
	}

	render() {
		let formGroupRows = [
			{
				formGroups: [{ id: 'username', label: translations[this.props.language].username, fieldType: 'text', labelFor: 'username', value: this.state.username, required: true, primaryCriteria: true,  error: this.state.errors['username'], hint: translations[this.props.language].username_hint  },  { id: 'email', label: translations[this.props.language].email, fieldType: 'email', labelFor: 'email', value: this.state.email, required: true, primaryCriteria: true,  error: this.state.errors['email']  }]
		  	},
			{
				formGroups: [{ id: 'password', label: translations[this.props.language].password, fieldType: 'password', labelFor: 'password', autoComplete: 'new-password', value: this.state.password, required: true,  primaryCriteria: true, error: this.state.errors['password'], hint: translations[this.props.language].password_hint, passwordRules: PASSWORD_RULES  }, { id: 'passwordConfirm', label: translations[this.props.language].confirm_password, fieldType: 'password', labelFor: 'passwordConfirm', autoComplete: 'new-password', value: this.state.passwordConfirm, required: true, primaryCriteria: true,  error: this.state.errors['passwordConfirm']  }]
			},			
			{
				formGroups: [{ id: 'firstName', label: translations[this.props.language].first_name, fieldType: 'text', labelFor: 'firstName', value: this.state.firstName, required: true, primaryCriteria: true }, { id: 'lastName', label: translations[this.props.language].last_name, fieldType: 'text', labelFor: 'lastName', value: this.state.lastName, required: true, primaryCriteria: true }]
		  	},
			{
			  	formGroups: [{ id: 'company', label: translations[this.props.language].company, fieldType: 'text', labelFor: 'company', value: this.state.company, required: false, error: this.state.errors['company']  }]
			},
			{
			  	formGroups: [{ id: 'address', label: translations[this.props.language].address, fieldType: 'text', labelFor: 'address', value: this.state.address, required: true, style: {minWidth: 400}, error: this.state.errors['address']  }]
			},
			{
			  	formGroups: [{ id: 'city', label: translations[this.props.language].city, fieldType: 'text', labelFor: 'city', value: this.state.city, required: true, error: this.state.errors['city']  }, { id: 'state', label: translations[this.props.language].state, fieldType: 'select', labelFor: 'state', required: true, value: this.state.state, options: usStates, error: this.state.errors['state']  }, { id: 'zip', label: translations[this.props.language].zip, fieldType: 'zip', labelFor: 'zip', value: this.state.zip, required: true, style: {maxWidth: 100, marginRight: 10}, error: this.state.errors['zip']  }]
			},
			{
				formGroups: [{ id: 'phoneFormatType', label: translations[this.props.language].phone_format, fieldType: 'select', labelFor: 'phoneFormatType', options: [{ code: "STANDARD", description: "(XXX) XXX-XXXX" }, { code: "INTERNATIONAL", description: "International" }], value: this.state.phoneFormatType, required: true, error: this.state.errors['phoneFormatType'] },
				             { id: 'phoneStandard', label: translations[this.props.language].phone, fieldType: 'tel', labelFor: 'phoneStandard', value: this.state.phoneStandard, required: true, hideField: this.state.phoneFormatType !== 'STANDARD', error: this.state.errors['phoneStandard'] },
							 { id: 'phoneInternational', label: translations[this.props.language].phone_with_country_code, labelFor: 'phoneInternational', fieldType: 'tel_international', value: this.state.phoneInternational, required: true, hideField: this.state.phoneFormatType !== 'INTERNATIONAL', error: this.state.errors['phoneInternational'] } ]
			}
		]

		const formProps = {
			componentName: "UserRegistration",
			pageHeading: translations[this.props.language].user_registration,
			onChange: this.handleChange,
			onSubmit: this.handleSubmit,
			onCancel: this.handleCancel,
			formGroupRows: formGroupRows,
			formOnly: true
		}

		return (
			<>
			<div style={{display: 'flex', flexDirection: 'column', minHeight: '100vh'}}>
                <LoginTop />
				<section className="cn container-fluid" style={{background: '#145A7B', flexGrow: 1 }}>
				<div style={{background: 'white', border: 'solid 3px black', borderRadius: 5, paddingBottom: 10, paddingLeft: 10, paddingRight: 10}}>
					<Container fluid="true" >
						<Row>
						<Col>
							<FormTemplate {...formProps} />
						</Col>
						</Row>
					</Container>
				</div>
				</section>
				<Footer />
			</div>
				<Loading loadingIndicator={this.state.status === LOADING_STATUES.LOADING} />
				<Alert show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} type={this.state.alertType} />
			</>
        )
    }
}

export default connect(mapStateToProps)(RegisterBig);